import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./config";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

async function loginWithGoogle() {
    try {
       return await signInWithPopup(auth, provider);
    } catch (error) {
        console.log(error);
        return error;
    }
}

function logout() {
    auth.signOut().then(() => {
        console.log("Logged out");
    }).catch((error) => {
        console.log(error);
    });
}




export { loginWithGoogle, logout };